const choices = {
    bad: 'Mauvaise',
    average: 'Moyenne',
    good: 'Bonne',
};

export default choices;
